module.exports = __webpack_public_path__ + "img/193.3c63417e.png";